const EXPORT_ACTION_TYPE = {
  GET_ALL_ARCHIVES: 'GET_ALL_ARCHIVES',
  GET_ONE_ARCHIVE: 'GET_ONE_ARCHIVE',
  DOWNLOAD_ONE_ARCHIVE: 'DOWNLOAD_ONE_ARCHIVE',
  EXPORT_REPORT: 'EXPORT_REPORT'
}
export default EXPORT_ACTION_TYPE
